import React from 'react';
import { useTranslation } from 'react-i18next';
import errorImage from '@/assets/images/error.webp';
import { Close } from '@/components/Icons/Close';
import { Modal } from '@/components/Modal';
import { useSwipeToClose } from '@/hooks/useSwipeToClose';
import { ModalVariant } from '@/types/components';

interface Props {
  isOpen?: boolean;
  onClose: () => void;
}

export const AbsenceOverlapModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const { sheetRef, swipeProps } = useSwipeToClose(onClose);

  return (
    <Modal
      isOpen
      label={t('absenceApplication.overlap.title')}
      variant={ModalVariant.BottomSheet}
      className="md:h-[308px] md:w-[400px]"
      contentRef={sheetRef}
      onClose={onClose}
    >
      <div
        {...swipeProps}
        className="flex shrink-0 flex-col max-md:cursor-grab max-md:touch-none max-md:active:cursor-grabbing"
      >
        <div className="mx-auto mt-2 h-[3px] w-10 rounded-full bg-drag-handle md:hidden" />
        <div className="flex items-center justify-end px-4 pt-2 pb-0 md:px-5 md:pt-5">
          <button
            type="button"
            onClick={onClose}
            aria-label={t('global.close')}
            className="hidden size-4 shrink-0 cursor-pointer items-center justify-center text-foreground md:flex"
          >
            <Close />
          </button>
        </div>
      </div>

      <div className="flex flex-1 flex-col items-center gap-2 px-4 pt-8 pb-[calc(48px+env(safe-area-inset-bottom))] md:justify-center md:px-10 md:pt-5 md:pb-6">
        <img
          src={errorImage}
          alt=""
          width={120}
          height={120}
          className="size-[120px]"
        />
        <div className="flex max-w-[320px] flex-col items-center gap-1 text-center">
          <h2 className="text-callout-16 text-foreground">
            {t('absenceApplication.overlap.title')}
          </h2>
          <p className="text-body-14 text-muted-foreground">
            {t('absenceApplication.overlap.description')}
          </p>
        </div>
      </div>
    </Modal>
  );
};
